import type { RouteParams } from "./types"

export function joinPatterns(parentPattern: string, segment: string) {
  if (segment.startsWith("/") || !parentPattern) {
    return segment
  }

  const parent = parentPattern === "/" ? "" : parentPattern.replace(/\/+$/g, "")
  const child = segment.replace(/^\/+|\/+$/g, "")

  return `${parent}/${child}`
}

export function formatPathParams(params?: RouteParams): Record<string, string | null> | undefined {
  if (!params) {
    return
  }

  return Object.fromEntries(Object.entries(params).map(([key, value]) => [key, value == null ? null : String(value)]))
}
